import { apolloClient } from '@lib/apollo';
import {
  DELETE_TIMETABLE_ITEM,
  delete_timetable_itemMutation,
  delete_timetable_itemMutationVariables,
} from '@app-types/graphql-types';
import { DeleteExistingTimetableItemsArgs } from '@modules/timetable';

export const deleteRemovedTimetableItems = async ({
  startOfWeek,
  endOfWeek,
  batchId,
  removedTimelineItems,
}: DeleteExistingTimetableItemsArgs): Promise<void> => {
  await apolloClient.mutate<delete_timetable_itemMutation, delete_timetable_itemMutationVariables>({
    mutation: DELETE_TIMETABLE_ITEM,
    variables: {
      where: {
        _and: [
          {
            id: {
              _in: removedTimelineItems,
            },
          },
          {
            startTime: {
              _gte: startOfWeek,
            },
          },
          {
            endTime: {
              _lte: endOfWeek,
            },
          },
          {
            batch_class: {
              batchId: {
                _eq: batchId,
              },
            },
          },
        ],
      },
    },
  });
};
